import React, { Component } from 'react';
import ImageList from './components/image-list';
import ProductDetail from './components/product-detail';
import ImageDetail from './components/image-detail';
import BodyText from './components/body-text';
import './styles/css/App.css';
import axios from 'axios';


class App extends Component {
  constructor(props) {
    super(props);
    // this.counter = 0;

    this.state = {
      images: [],
      variants: [],
      bodyHtml: '',
      title: null,
      selectedImage: null
    }
  }

  //Used the 'shouldComponentUpdate' function to test the performance and number of times the 
  //page was being loaded. This returned a counter where i found the page was loading 3 times.
  //This was resolved using 'npm link' which prevented multiple page loads and 
  //improve performance.

  // shouldComponentUpdate(nextProps, nextState) {
  //   return this.props.children == nextProps.children;
  // }

  //the function "componentDidMount" is used to make server call to 
  //get the data provided through Mocky
  componentDidMount() {
    return axios
      .get("https://www.mocky.io/v2/5b3a92482e0000eb20158265")
      .then((result) => {
        this.setState({
          selectedImage: result.data.product.images[3].src1130,
          images: result.data.product.images,
          bodyHtml: result.data.product.body_html,
          variants: result.data.product.variants,
          title: result.data.product.title
        })
      })
  }

  render() {
    return (
      <div className='wrapper'>
        {/* `I should be rendered only 1 time. actual times rendered: ${++this.counter}`; */}
        <ImageList
          images={this.state.images}
          onImageSelect={selectedImage => this.setState({ selectedImage })} />
        <ImageDetail
          image={this.state.selectedImage} />
        <BodyText
          text={this.state.bodyHtml} />
        <ProductDetail
          variants={this.state.variants}
          images={this.state.images}
          title={this.state.title} />
      </div>
    );

  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js